import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconMenuBold';
/** Renders an SVG icon. */
const SvgMenuBold = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 8a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2m0 8a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2m0 8a2 2 0 0 1 2-2h20a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2"
      />
    </svg>
  );
};
SvgMenuBold.displayName = displayName;
export default SvgMenuBold;
